module.exports = __webpack_public_path__ + "img/question.2855b1f4.svg";